<template>
  <v-layout>
    <v-row>
      <v-col class="py-0 my-1">
        <v-card width="100%">
          <div>
            <v-chip class="ma-2" color="teal" text-color="white">
              <b><span v-html="title"></span></b>              
            </v-chip>
            <HelpIcon :help="htext"/>
          </div>
          <v-text-field
            class="ttext my-0 px-1"
            readonly
            outline
            hide-details
            v-model="infor.schKH"
            label="ឈ្មោះសាលារៀន(ឆ្នាំមុន)"
          >
          </v-text-field>
          <v-text-field
            class="ttext my-0 px-1"
            readonly
            outline
            hide-details
            v-model="infor.schEN"
            label="ឈ្មោះសាលារៀន(ឆ្នាំមុន)ឡាតាំង"
          >
          </v-text-field>

          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="infor.schnewKH"
            label="ឈ្មោះសាលារៀន(បច្ចុប្បន្ន)"
          >
          </v-text-field>
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="infor.schnewEN"
            label="ឈ្មោះសាលារៀន(បច្ចុប្បន្ន)ឡាតាំង"
          >
          </v-text-field>

          <v-text-field
            class="ttext my-0 px-1"
            readonly
            outline
            hide-details
            v-model="infor.Village_KH"
            label="ភូមិ"
          >
          </v-text-field>
          <v-text-field
            class="ttext my-0 px-1"
            readonly
            outline
            hide-details
            v-model="infor.Commune_KH"
            label="ឃុំ/សង្កាត់"
          >
          </v-text-field>
          <v-text-field
            class="ttext my-0 px-1"
            readonly
            outline
            hide-details
            v-model="infor.DisName_KH"
            label="ក្រុង/ស្រុក/ខណ្ឌ"
          >
          </v-text-field>
          <v-text-field
            class="ttext my-0 px-1"
            readonly
            outline
            hide-details
            v-model="infor.ProName_KH"
            label="រាជធានី/ខេត្ត "
          >
          </v-text-field>

          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            v-model="data.sctl"
            label="លេខទូរស័ព្ទការិយាល័យរដ្ឋបាល"
          >
          </v-text-field>
          <v-select
            class="px-1"
            v-model="data.nush"
            :items="numShift2"
            item-text="text"
            item-value="value"            
            outline
            label="ចំនួនវេនរៀន"
            hide-details
            @keypress.native="onSelect($event)"
          />          
          <!--
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            type="number"
            v-model="data.total_lower"
            label="សរុបចំនួនបុគ្គលិកបង្រៀននៅមធ្យមសិក្សាបឋមភូមិ"
          >
          </v-text-field>
          <v-text-field
            class="ttext my-0 px-1"
            outline
            hide-details
            type="number"
            v-model="data.total_upper"
            label="ចំនួនបុគ្គលិកបង្រៀនជាស្ត្រីនៅមធ្យមសិក្សាបឋមភូមិ"
          >
          </v-text-field>
          -->          
          <v-select
            class="px-1 big-label"
            v-model="data.sepk"
            :items="privSchType"
            item-text="text"
            item-value="value"
            outline
            label="ជាសាលារៀនដែលមានកម្រិតថ្នាក់៖"
            hide-details            
            @keypress.native="onSelect2($event)"
          />          
                 
          <v-text-field
            class="ttext my-0 px-1"            
            outline
            hide-details
            v-model="data.scbr"
            type="number"
            label="សាខាទី"
          >
          </v-text-field>

          <v-select
            class="px-1"
            v-model="data.ingo"
            :items="yesNo"
            item-text="text"
            item-value="value"
            outline
            label="ជាសាលាអង្គការ"
            hide-details
            @keypress.native="onSelect3($event)"
          />    

          <v-select
            class="px-1"
            v-model="data.irel"
            :items="yesNo"
            item-text="text"
            item-value="value"
            outline
            label="ជាសាលាសាសនា"
            hide-details
            @keypress.native="onSelect4($event)"
          />    
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import { privSchType } from "@/utils/priascf/commonVariables.js";
import { numShift2, yesNo } from "@/utils/ascf/commonConfig.js";

export default {
  props: ["data", "infor", "title", "htext"],
  data() {
    return {
      numShift2: numShift2,
      privSchType: privSchType,
      yesNo: yesNo
    };
  },
  methods: {
    onSelect: function (event) {
      // number of shift for 1 shift 2 shift
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 51) {
        // 3 options
        this.data.nush = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect2: function (event) {      
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 57) {
        // 3 options
        this.data.sepk = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect3: function (event) {      
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 51) {
        // 3 options
        this.data.ingo = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect4: function (event) {      
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 51) {
        // 3 options
        this.data.irel = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
.big-label .v-label {
  font-size: 18px !important;
  font-weight: bold !important;
}
</style>